const keys = {
  serverUrl: 'https://cv-cloud-server-v25-d7d4ce152279.herokuapp.com',
}

export default keys

